import { useEffect, useRef, useState } from 'react'
import { useV2SContext } from './V2SProvider'

export const useSpeechToText = () => {
    const [finalTranscript, setFinalTranscript] = useState('')
    const [interimTranscript, setInterimTranscript] = useState('')
    const [isRecording, setIsRecording] = useState(false)
    const recognitionRef = useRef<any>(null)
    const {language} = useV2SContext()

    useEffect(() => {
        const SpeechRecognition = (window as any).webkitSpeechRecognition
        if (!SpeechRecognition) {
            alert('Speech Recognition not supported in this browser.')
            return
        }

        const recognition = new SpeechRecognition()
        recognition.lang = language
        recognition.continuous = true
        recognition.interimResults = true

        recognition.onstart = () => {
            console.log('🎙️ Speech recognition started')
        }

        recognition.onerror = (e: any) => console.error('❌ Speech recognition error:', e)
        recognition.onend = () => console.log('🛑 Speech recognition ended')

        recognition.onresult = (event: any) => {
            let interim = ''
            let final = ''

            for (let i = event.resultIndex; i < event.results.length; ++i) {
                const result = event.results[i]
                const transcriptChunk = result[0].transcript

                if (result.isFinal) {
                    final += transcriptChunk
                } else {
                    interim += transcriptChunk
                }
            }

            if (final) {
                setFinalTranscript((prev) => prev + final)
                setInterimTranscript('') // clear once confirmed
            } else {
                setInterimTranscript(interim)
            }
        }

        recognitionRef.current = recognition
    }, [language])

    const start = () => {
        setFinalTranscript('')
        setInterimTranscript('')
        recognitionRef.current?.start()
        setIsRecording(true)
    }

    const stop = () => {
        recognitionRef.current?.stop()
        setIsRecording(false)
    }

    return {
        transcript: finalTranscript + interimTranscript,
        isRecording,
        start,
        stop,
    }
}
